import { FormularioCampo } from '@/types/formulario';

export function usePlanoAcaoTrigger() {
  const verificarDisparo = (
    campo: FormularioCampo,
    valorResposta: any
  ): boolean => {
    const config = campo.configuracoes?.plano_acao;
    if (!config?.habilitado) return false;
    
    const condicao = config.condicao_disparo;
    
    switch (condicao.tipo) {
      case 'valor_especifico':
        return condicao.valores?.includes(String(valorResposta)) || false;
      
      case 'opcao_selecionada':
        if (Array.isArray(valorResposta)) {
          return valorResposta.some(v => condicao.valores?.includes(v));
        }
        return condicao.valores?.includes(String(valorResposta)) || false;
      
      case 'range':
        const numVal = Number(valorResposta);
        const min = condicao.min ?? -Infinity;
        const max = condicao.max ?? Infinity;
        return numVal >= min && numVal <= max;
      
      case 'pattern':
        if (condicao.operador === 'contem') {
          return condicao.valores?.some(v => 
            String(valorResposta).toLowerCase().includes(v.toLowerCase())
          ) || false;
        }
        return false;
      
      default:
        return false;
    }
  };
  
  return { verificarDisparo };
}
